<div class="absolute right-0 pr-5 pt-2 space-y-2 flex flex-col">
    <div *ngFor="let message of getMessages()" class="text-right">
        <span class="bg-opacity-70 py-1 px-2 rounded-md w-auto"
            [ngClass]="{'bg-red-500 text-red-100': message.type === 'error', 'bg-blue-500 text-blue-100': message.type === 'info', 'bg-green-500 text-green-100': message.type === 'success'}">
            {{ display(message) }}
        </span>
    </div>
</div>